import { render } from "./PetDescription.vue?vue&type=template&id=7279b988&scoped=true"
import script from "./PetDescription.vue?vue&type=script&lang=js"
export * from "./PetDescription.vue?vue&type=script&lang=js"

import "./PetDescription.vue?vue&type=style&index=0&id=7279b988&scoped=true&lang=sass"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7279b988"]])

export default __exports__